import { render, staticRenderFns } from "./arrow-down.vue?vue&type=template&id=739f3874&scoped=true&"
import script from "./arrow-down.vue?vue&type=script&lang=js&"
export * from "./arrow-down.vue?vue&type=script&lang=js&"
import style0 from "./arrow-down.vue?vue&type=style&index=0&id=739f3874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739f3874",
  null
  
)

export default component.exports